import { ChevronRight } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { useDialog } from 'common/hooks/useDialog';
import { formatCurrency } from 'common/utils/formatUtils';
import { CashFlowAdjustmentFragment } from 'generated/graphql';
import { useTranslation } from 'react-i18next';

import { CashFlowAdjustmentType } from '../AddCashFlowAdjustmentDialog/AddCashFlowAdjustmentDialog';
import {
  CashFlowAdjustmentDetailDialog,
  CashFlowAdjustmentDetailDialogProps,
} from '../CashFlowAdjustmentDetailDialog/CashFlowAdjustmentDetailDialog';
import { styles } from './CashFlowAdjustmentListItem.styles';

export interface CashFlowAdjustmentListItemProps {
  cashFlowAdjustment: CashFlowAdjustmentFragment;
}

export const CashFlowAdjustmentListItem: React.FC<CashFlowAdjustmentListItemProps> = ({ cashFlowAdjustment }) => {
  const { i18n } = useTranslation();

  const amount = cashFlowAdjustment.period.expectedAmount?.amount ?? 0;

  const cashFlowAdjustmentDetailDialog = useDialog<CashFlowAdjustmentDetailDialogProps, void>(
    CashFlowAdjustmentDetailDialog,
    {
      id: cashFlowAdjustment.id,
      instanceId: `edit-cash-flow-adjustment-${cashFlowAdjustment.id}`,
      navigable: true,
    },
  );

  const handleCashFlowAdjustmentListItemClick = async () => {
    await cashFlowAdjustmentDetailDialog.create({
      id: cashFlowAdjustment.id,
      type: (amount ?? 0) > 0 ? CashFlowAdjustmentType.Income : CashFlowAdjustmentType.Expense,
    });
  };

  return (
    <Box onClick={handleCashFlowAdjustmentListItemClick} sx={styles.clickableRow}>
      <Stack direction="row" flexGrow={1} justifyContent="space-between">
        <Typography variant="bodyL">{cashFlowAdjustment.text}</Typography>
        <Typography color={'textSecondary'} variant="bodyL">
          {formatCurrency(Math.abs(amount), i18n.language)}
        </Typography>
      </Stack>
      <ChevronRight sx={styles.icon} />
    </Box>
  );
};
